import { GridColumn } from "@ucl/library";

export const boltDocumentTemplateGridColumns: GridColumn[] = [
  new GridColumn({
    field: "templateName",
    headerText: "Template Name",
    type: "string",
    width: 400,
  }),
  new GridColumn({
    field: "displayFileName",
    headerText: "File Name",
    type: "string",
    width: 500,
  }),
  new GridColumn({
    field: "uploadedAt_AsDateOnly",
    headerText: "Uploaded Date",
    type: "date",
    format: { format: "MM/dd/yyyy", type: "date" },
    allowSearching: false,
    minWidth: 100,
  }),
];
